export default __webpack_public_path__ + "static/media/vi.b443914d.png";